import React from "react";
import styled from "styled-components";
import Navbar from "../Navbar/Navbar";
import Landing from "../../assets/icons/LandingPage.png";
import fipayFonts from "../../theme/index";
import { NavbarWrapper } from "../PrivacyPolicy/Page";

interface ContactUsHeroProps {}

const textContent = [
  {
    imgPath: "/assets/icons/contact-us.png",
    TextHeader: "Contact Us",
    MidFirstText: `Fipay is a digital payment Lorem ipsum dolor sit amet, consectetur
    adipiscing elit. Donec tempus libero nulla, nec dignissim nisi
    semper ac.`,
  },
];

const ContactUsHero: React.FC<ContactUsHeroProps> = () => {
  return (
    <Container>
      <Navbar />

      <ContactUsHeroContainer>
        <ContacUsUsContent>
          <ContactUsTitle>{textContent[0].TextHeader}</ContactUsTitle>
          <ContactUsText>
            <FirstParagraph>{textContent[0].MidFirstText}</FirstParagraph>
            <ContactInfoContainer>
              <ContactInfo>
                <Icon src="/assets/icons/email.png" alt="Email" />
                <span>Email us: Contact@fipay.io</span>
              </ContactInfo>
              <ContactInfo>
                <Icon src="/assets/icons/call-calling.png" alt="Phone" />
                <span>Call: +1-756-234-567</span>
              </ContactInfo>
              <ContactInfo>
                <Icon src="/assets/icons/messages-3.png" alt="Chat" />
                <span>Chat with us</span>
              </ContactInfo>
            </ContactInfoContainer>
          </ContactUsText>
        </ContacUsUsContent>
        <VisionImage src={textContent[0].imgPath} alt="Vision" />
      </ContactUsHeroContainer>
    </Container>
  );
};

const Container = styled.div`
  background-image: url("/assets/icons/LandingPage.jpg");
  display: flex;
  align-items: center;
  background-size: cover;
  flex-direction: column;
  @media (max-width: 850px) {
    background-image: url("/assets/icons/LandingPage.jpg");
    background-size: cover;
  }
`;

const ContactUsHeroContainer = styled.section`
  display: flex;
  align-items: left;
  justify-content: space-between;
  padding: 2rem;

  @media (max-width: 850px) {
    flex-direction: column;
    align-items: center;
    margin: 0rem;
    padding: 0rem;
  }
`;

const ContactUsTitle = styled.h1`
  font-family: GT Walsheim Pro;
  font-size: 60px;
  font-weight: 700;
  line-height: 78px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-bottom: 0px;
  color: #09005b;
  @media screen and (min-width: 0px) and (max-width: 850px) {
    font-size: 30px;
    line-height: 34.35px;
  }
  ${fipayFonts.fipayFonts.heading1};
`;

const FirstParagraph = styled.p`
  margin-bottom: 2rem;
  color: #5e5e5e;
`;

const VisionImage = styled.img`
  width: 90%;
  height: auto;
  @media screen and (min-width: 0px) and (max-width: 950px) {
    margin-left: 1rem;
    align-items: center;
  }
`;

const ContactUsText = styled.p`
  text-align: left;
  padding: 0;
  margin: 0;
  ${fipayFonts.fipayFonts.body1};
`;

const ContacUsUsContent = styled.div`
  padding-left: 3rem;
  padding-top: 4rem;
  padding-right: 9rem;

  @media screen and (min-width: 0px) and (max-width: 950px) {
    padding: 2rem;
    align-items: center;
  }
`;

const ContactInfoContainer = styled.div`
  margin-top: 2rem;
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  & > span {
    margin-left: 1rem;
  }
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
`;

export default ContactUsHero;
